import { useEffect, useRef, useState } from "react";

// Taken from:
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useCountUp(ns, started, duration = 500, interval = 20) {
  const [count, setCount] = useState(() => ns.map(() => 0));

  useInterval(
    () => {
      setCount(count.map((c, i) => c + (ns[i] * interval) / duration));
    },
    !started || count[0] >= ns[0] ? null : interval
  );

  return count.map(e => e | 0);
}
